<div class="flex overflow-y-auto w-auto overflow-x-hidden fixed right-0 left-0 top-4 z-40 justify-center items-center md:inset-0 h-modal sm:h-full"
    [id]="modalId" tabindex="-1" aria-hidden="true">
    <div class="absolute inset-0 bg-black bg-opacity-25 backdrop-blur-sm"></div>

    <div class="relative px-4 w-full max-w-4xl h-full md:h-auto">

        <div class="relative bg-white rounded-2xl shadow-lg">

            <div class="flex justify-end p-2">
                <ng-content select="[modal-button-close]"></ng-content>
            </div>

            <div class="p-6 pt-0 text-center">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>